import { getAvailabilityAPMs } from '@/clientState/commonFunctions';
import { PaymentMethod } from '@/generated/graphql';
import type { APMConfType } from './types';

const { isApplePayAvailable } = getAvailabilityAPMs();

// This configuration is used to determine conditions related to browser compatibility and other factors which cannot be determined by the backend.
// Take into account this configuration won't be able to have logic to filter APMs based on other different factors mentioned before.
export const APM_CONF: APMConfType = {
  [PaymentMethod.Applepay]: {
    shouldShow: isApplePayAvailable,
  },
};
